(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["velvet-buying-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('velvet-buying-guide')) {
    customElements.define('velvet-buying-guide', class extends HTMLElement {
      connectedCallback() {
        this.scents = JSON.parse(this.dataset.scents || '[]');
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
        this.mobileButton = this.querySelector('[data-mobile-submit]');
        this.mobileBar = this.querySelector('[data-mobile-purchase]');
        if (this.mainButton) {
          this.observer = new IntersectionObserver(entries => { this.mobileBar.hidden = entries[0].isIntersecting; }, {threshold:0});
          this.observer.observe(this.mainButton);
          this.buttonObserver = new MutationObserver(() => this.syncButton());
          this.buttonObserver.observe(this.mainButton, {attributes:true,childList:true,subtree:true});
          this.syncButton();
        }
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
            if (event.data.sectionId !== this.dataset.section) return;
            const title = event.data.variant.title;
            const scent = this.scents.find(item => item.name.trim() === title.trim()) || (this.dataset.single === 'true' ? this.scents[0] : null);
            this.querySelector('[data-scent-name]').textContent = scent ? scent.name : title;
            this.querySelector('[data-scent-text]').textContent = scent ? scent.text : '';
            const source = event.data.html.querySelector(`[id="price-${this.dataset.section}"] .price-item--regular`);
            if (source) this.querySelector('[data-mobile-price]').textContent = source.textContent.trim();
            this.syncButton();
          });
        }
      }
      syncButton() {
        this.mobileButton.disabled = this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';
        const text = [...this.mainButton.children].find(el => el.tagName === 'SPAN' && !el.classList.contains('loading__spinner'));
        if (text) this.mobileButton.textContent = text.textContent.trim();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.buttonObserver?.disconnect();
        this.unsubscribe?.();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["velvet-inquiry-form"] && !Shopify.designMode) return;
  try {
    function velvetPrefillTopic() {
    const requested = new URLSearchParams(window.location.search).get('topic');
    if (!['general','order','workshop','waitlist','wholesale','subscription'].includes(requested)) return;
    document.querySelectorAll('[data-ve-topic]').forEach(select => { select.value = requested; });
  }
  velvetPrefillTopic();
  document.addEventListener('shopify:section:load', velvetPrefillTopic);
  } catch(e) { console.error(e); }
})();

})();
